import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import React, { memo } from "react";
import SectionContainer from "../../../../../common/SectionContainer";
import { Data } from "../../../../../store/terminal/types";
import { FastField, FormikProps, useFormikContext } from "formik";
import NumberFormat from "react-number-format";
import CustomizedSwitch from "../../../../../common/formElements/Switch";
import { get } from "lodash";
import OptionalToolTip from "../../../../../common/toolTip/OptionalToolTip";
import { connect } from "react-redux";
import { ConfigPropExtenderHoc } from "../../../../../common/StaticConfigProvider";

interface EditDRCProps {
  // bulk: boolean;
  toolTips?: { terminals?: { options?: Record<string, string> } };
  isUpdateAllowed?: boolean;
  bulk: boolean;
  shouldHideField: (fieldName: string) => boolean;
}

function EditDRCForm(props: EditDRCProps) {
  const formProps = useFormikContext<FormikProps<Data>>();
  const { isUpdateAllowed, bulk, shouldHideField } = props;
  const { setFieldValue } = formProps;
  const values = (formProps.values as unknown) as Data;
  const errors = (formProps.errors as unknown) as Data;
  return (
    <SectionContainer name="sections.drcForm">
      <Grid container alignItems="flex-start" spacing={2}>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <OptionalToolTip
              tooltip={get(
                props,
                `toolTips.terminals.options.drc.DRCMinLoyaltyAmount`
              )}
            >
              <FastField
                name="attributes.DRCMinLoyaltyAmount"
                variant="outlined"
                as={NumberFormat}
                customInput={TextField}
                isNumericString={false}
                error={errors.attributes?.DRCMinLoyaltyAmount}
                helperText={errors.attributes?.DRCMinLoyaltyAmount}
                label="Minimum Loyalty Amount (Cents Whole Number)"
                onInput={(e: { target: HTMLInputElement }) => {
                  const target = e.target as HTMLInputElement;
                  target.value = target.value.replace(/[^0-9]/g, "");
                }}
                fullWidth
                thousandSeparator={false}
                prefix={""}
                decimalScale={0}
                fixedDecimalScale={true}
                inputProps={
                  {
                    // readOnly: isUserConfigChecked,
                  }
                }
                disabled={!isUpdateAllowed}
              />
            </OptionalToolTip>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <OptionalToolTip
              tooltip={get(props, `toolTips.terminals.options.drc.DRCStoreId`)}
            >
              <FastField
                name="attributes.DRCStoreId"
                variant="outlined"
                as={TextField}
                error={errors?.attributes?.DRCStoreId}
                helperText={errors?.attributes?.DRCStoreId}
                label="Store ID"
                fullWidth
                disabled={!isUpdateAllowed}
              />
            </OptionalToolTip>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <OptionalToolTip
              tooltip={get(
                props,
                `toolTips.terminals.options.drc.FeatureDRCLoyaltyCashPassword`
              )}
            >
              <FastField
                name="attributes.FeatureDRCLoyaltyCashPassword"
                variant="outlined"
                as={TextField}
                error={errors?.attributes?.FeatureDRCLoyaltyCashPassword}
                helperText={errors?.attributes?.FeatureDRCLoyaltyCashPassword}
                label="Loyalty Cash Password"
                fullWidth
                disabled={!isUpdateAllowed}
              />
            </OptionalToolTip>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <OptionalToolTip
              tooltip={get(
                props,
                `toolTips.terminals.options.drc.DRCLoyaltyLogoUrl`
              )}
            >
              <FastField
                name="attributes.DRCLoyaltyLogoUrl"
                variant="outlined"
                as={TextField}
                error={errors?.attributes?.DRCLoyaltyLogoUrl}
                helperText={errors?.attributes?.DRCLoyaltyLogoUrl}
                label="Loyalty Logo URL"
                fullWidth
                disabled={!isUpdateAllowed}
              />
            </OptionalToolTip>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <OptionalToolTip
            tooltip={get(
              props,
              `toolTips.terminals.options.drc.FeatureDRCLoyaltyCashPasswordProtect`
            )}
          >
            <FormControlLabel
              style={{ marginLeft: "5px" }}
              control={
                <CustomizedSwitch
                  checked={
                    get(
                      values,
                      "attributes.FeatureDRCLoyaltyCashPasswordProtect"
                    ) === "Yes"
                  }
                  onChange={(event, value) => {
                    setFieldValue(
                      "attributes.FeatureDRCLoyaltyCashPasswordProtect",
                      value ? "Yes" : "No"
                    );
                  }}
                  disabled={!isUpdateAllowed}
                />
              }
              label="Enable DRC Cash Password Protect"
            />
          </OptionalToolTip>
        </Grid>
      </Grid>
    </SectionContainer>
  );
}

const ConnectedDRC = connect(
  null,
  null,
  (_stateProps, _dispatchProps, ownProps: EditDRCProps) => {
    return {
      ...ownProps,
    };
  }
)(EditDRCForm);

const ConnectedDRCHoc = (props: EditDRCProps) => (
  // @ts-ignore
  <ConfigPropExtenderHoc propName="toolTips">
    <ConnectedDRC {...props} />
  </ConfigPropExtenderHoc>
);

export default ConnectedDRCHoc;
